import { render } from "./TransferPaymentDateSwitchContainer.vue?vue&type=template&id=7361527d"
import script from "./TransferPaymentDateSwitchContainer.vue?vue&type=script&lang=js"
export * from "./TransferPaymentDateSwitchContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__